<div class="dialog-container">
    <h2>{{ data.title }}</h2>
    <mat-dialog-content>
        <mat-form-field appearance="outline" style="width: 100%" floatLabel="auto" appearance="fill" color="primary">
            <mat-label>{{ data.label }}</mat-label>
            <input matInput [(ngModel)]="inputValue" />
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button class="secondary-button" (click)="onCancel()">Zurück</button>
        <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!inputValue">Speichern</button>
    </mat-dialog-actions>
</div>